<template>
  <div class="overflow-x justify-content-center ">
      <div class=" p-list-representation-table-main ">
        <table class="table table-bordered p-table p-management-commission-gender-table">
            <thead>
              <tr>
                <th></th>
                <th>شنبه</th>
                <th >یک شنبه</th>
                <th >دوشنبه</th>
                <th >سه شنبه</th>
                <th >چهار شنبه</th>
                <th >پنج شنبه</th>
                <th >جمعه</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in tableData" :key="data.id">

                <th scope="row">
                    <div class="d-flex justify-content-center">
                          <div class="d-flex ml-1">
                            <h3 class="ml-2">ساعت </h3>
                            <h3>{{data.setHour.start_time}}</h3>
                          </div>
                          <div class="d-flex">
                            <h3 class="ml-1">تا</h3>
                            <h3>{{data.setHour.end_time}}</h3>
                          </div>
                    </div>
                </th>

                <th
                :class="{'p-management-commission-gender-help-bg-gray':data.sat.gender == 'unset' , 'p-management-commission-gender-help-bg-pink':data.sat.gender == 'female' , 'p-management-commission-gender-help-bg-blue':data.sat.gender == 'male'}"
                >
                  <div class="row p-management-commission-gender-item flex-column ">
                      <h3 class="p-management-commission-gender-percent">{{data.sat.system_porsant}}%</h3>
                      <button @click="showModalEditManagementCommission(data.sat)" type="button" class="btn btn-primary btn-blue btn-sm remove-radius mt-3  p-management-commission-gender-edit-btn">ویرایش </button>
                    </div>
                </th>

                <th
                :class="{'p-management-commission-gender-help-bg-gray':data.sun.gender == 'unset' , 'p-management-commission-gender-help-bg-pink':data.sun.gender == 'female' , 'p-management-commission-gender-help-bg-blue':data.sun.gender == 'male'}"
                >
                  <div class="row p-management-commission-gender-item flex-column">
                    <h3 class="p-management-commission-gender-percent">{{data.sun.system_porsant}}%</h3>
                    <button @click="showModalEditManagementCommission(data.sun)" type="button" class="btn btn-primary btn-blue btn-sm remove-radius mt-3  p-management-commission-gender-edit-btn">ویرایش </button>
                  </div>
                </th>

                <th
                :class="{'p-management-commission-gender-help-bg-gray':data.mon.gender == 'unset' , 'p-management-commission-gender-help-bg-pink':data.mon.gender == 'female' , 'p-management-commission-gender-help-bg-blue':data.mon.gender == 'male'}"
                >
                  <div class="row p-management-commission-gender-item flex-column">
                    <h3 class="p-management-commission-gender-percent">{{data.mon.system_porsant}}%</h3>
                    <button @click="showModalEditManagementCommission(data.mon)" type="button" class="btn btn-primary btn-blue btn-sm remove-radius mt-3  p-management-commission-gender-edit-btn">ویرایش </button>
                  </div>
                </th>

                <th
                :class="{'p-management-commission-gender-help-bg-gray':data.tue.gender == 'unset' , 'p-management-commission-gender-help-bg-pink':data.tue.gender == 'female' , 'p-management-commission-gender-help-bg-blue':data.tue.gender == 'male'}"
                >
                  <div class="row p-management-commission-gender-item flex-column">
                    <h3 class="p-management-commission-gender-percent">{{data.tue.system_porsant}}%</h3>
                    <button @click="showModalEditManagementCommission(data.tue)" type="button" class="btn btn-primary btn-blue btn-sm remove-radius mt-3  p-management-commission-gender-edit-btn">ویرایش </button>
                  </div>
                </th>

                <th
                :class="{'p-management-commission-gender-help-bg-gray':data.wed.gender == 'unset' , 'p-management-commission-gender-help-bg-pink':data.wed.gender == 'female' , 'p-management-commission-gender-help-bg-blue':data.wed.gender == 'male'}"
                >
                  <div class="row p-management-commission-gender-item flex-column">
                    <h3 class="p-management-commission-gender-percent">{{data.wed.system_porsant}}%</h3>
                    <button @click="showModalEditManagementCommission(data.wed)" type="button" class="btn btn-primary btn-blue btn-sm remove-radius mt-3  p-management-commission-gender-edit-btn">ویرایش </button>
                  </div>
                </th>

                <th
                :class="{'p-management-commission-gender-help-bg-gray':data.thu.gender == 'unset' , 'p-management-commission-gender-help-bg-pink':data.thu.gender == 'female' , 'p-management-commission-gender-help-bg-blue':data.thu.gender == 'male'}"
                >
                  <div class="row p-management-commission-gender-item flex-column">
                    <h3 class="p-management-commission-gender-percent">{{data.thu.system_porsant}}%</h3>
                    <button @click="showModalEditManagementCommission(data.thu)" type="button" class="btn btn-primary btn-blue btn-sm remove-radius mt-3  p-management-commission-gender-edit-btn">ویرایش </button>
                  </div>
                </th>

                <th
                :class="{'p-management-commission-gender-help-bg-gray':data.fri.gender == 'unset' , 'p-management-commission-gender-help-bg-pink':data.fri.gender == 'female' , 'p-management-commission-gender-help-bg-blue':data.fri.gender == 'male'}"
                >
                  <div class="row p-management-commission-gender-item flex-column">
                    <h3 class="p-management-commission-gender-percent">{{data.fri.system_porsant}}%</h3>
                    <button @click="showModalEditManagementCommission(data.fri)" type="button" class="btn btn-primary btn-blue btn-sm remove-radius mt-3  p-management-commission-gender-edit-btn">ویرایش </button>
                  </div>
                </th>


              </tr>

            </tbody>
          </table>
          <!-- <div class="d-flex justify-content-center p-table">
            <pagination v-model="valuePage" :per-page="10" :records="500" @paginate="changePage"/>
          </div> -->
      </div>

      <div class=" row p-management-commission-gender-help p-table mt-4 justify-content-center">
            <div class="d-flex p-management-commission-gender-help-item align-items-center ml-4">
              <div class="p-management-commission-gender-help-bg-blue p-management-commission-gender-help-data"></div>
              <h3 class="p-management-commission-gender-help-title mr-2">آقایان</h3>
            </div>
            <div class="d-flex p-management-commission-gender-help-item align-items-center ml-4">
              <div class="p-management-commission-gender-help-bg-pink p-management-commission-gender-help-data"></div>
              <h3 class="p-management-commission-gender-help-title mr-2">بانوان </h3>
            </div>
            <div class="d-flex p-management-commission-gender-help-item align-items-center">
              <div class="p-management-commission-gender-help-bg-gray p-management-commission-gender-help-data"></div>
              <h3 class="p-management-commission-gender-help-title mr-2">هر دو</h3>
            </div>
      </div>

  </div>
</template>

<script>


export default {
    name: 'tableContent',
    props: {
      tableData : { type: [Array, Object], default: [] },
      page      : { type: Number, default: 0 },
    },

    data() {
      return {
        valuePage : 1,
      }
    },


    computed: {

    },

    mounted () {
      this.valuePage = this.page;
    },

    watch: {
      page(data){
        this.valuePage = this.page;
      },

    },

    methods: {
      changePage(data){
        this.$emit("paganationChangePage",data);
      },

      showModalEditManagementCommission(data){
        this.$emit("showModalEditManagementCommission",data);
      },


    },

}
</script>
